<div class="parameters">
  @for (param of parametersArray.controls; track param; let i = $index) {
    <div class="parameter" [formGroup]="asFormGroup(param)">
      <div class="parameter-name">
        <div class="label">Parameter Name:</div>
        <wm-editable-inlinetext formControlName="key" [saveIcon]="faCheck" [renderHtml]="false"></wm-editable-inlinetext>
      </div>
      <div class="parameter-value">
        <div class="label">Value:</div>
        @switch (asFormGroup(param).get('exprType')?.value) {
          @case ('ConstHTMLStringReportExpr') {
            <wm-editable-inlinetext formControlName="value" [saveIcon]="faCheck" [renderHtml]="false"></wm-editable-inlinetext>
          }
          @case ('EnumReportExpr') {
            <p-select formControlName="value"
                      [options]="asFormGroup(param).get('options')?.value"
                      [editable]="true"
                      placeholder="Select a value">
            </p-select>
          }
          @default {
            <span class="unsupported-type">{{ asFormGroup(param).get('exprType')?.value }}</span>
          }
        }
      </div>
      <div class="parameter-actions">
        <p-button icon="true" styleClass="p-button-text" (click)="removeParameter(i)">
          <fa-icon [icon]="faTrash"></fa-icon>
        </p-button>
      </div>
    </div>
  }
  @if (allowAdd) {
    <div class="add-button">
      <p-button label="Add Parameter" styleClass="p-button-secondary" (click)="addParameter()">
        <fa-icon [icon]="faPlus"></fa-icon>
      </p-button>
    </div>
  }
</div>
